document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("index-swiper")) {
    class IndexSwiper extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector(".index-swiper-container");
        this.current_index = 0;
        this.youtube_list = this.querySelectorAll("[data-plyr-provider]");
        this.size = this.dataset.size;
        this.video_btn = this.querySelectorAll(".index-swiper-btn");
        this.swiper_obj = this.querySelector(".swiper");
        this.swiper = null;
        this.player_list = [];
        this.line_clamp=this.getAttribute("data-line_clamp")
        this.video_first_play=this.getAttribute("data-video_first_play")=='true'? true : false;
        const ua = navigator.userAgent || "";
        this.allow_fullscreen = !/iphone|ipad|ipod/i.test(ua);
      }
      connectedCallback() {
        this.detectObserver();
      }
      detectObserver() {
        let height = window.innerHeight / 2;
        if (this.container) {
          const resizeObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.initDetectVideo();
                this.initSwiper();
                this.initVideoBtnClickEvent();
                if(this.line_clamp>0){
                  this.initLineClamp()
                }
                resizeObserver.disconnect();
              }
            },
            { threshold: 0, rootMargin: `${height}px 0px 0px 0px` }
          );
          resizeObserver.observe(this.container);
        }
      }
      initDetectVideo() {
        if (!this.youtube_list) return;
        for (let item of this.youtube_list) {
          const ite = new Plyr(item, {
            controls: ["progress", "fullscreen"],
            tooltips: { controls: false, seek: false },
          });
          this.player_list.push(ite);
        }
        this.playFirstVideo();
      }
      initSwiper() {
        if (!this.swiper_obj) return;
        const slider_pc_num = this.getAttribute("data-swiper_pc_num")
          ? this.getAttribute("data-swiper_pc_num")
          : 1;
        const slider_ipad_num = this.getAttribute("data-swiper_ipad_num")
          ? this.getAttribute("data-swiper_ipad_num")
          : slider_pc_num;
        const slider_m_num = this.getAttribute("data-swiper_m_num")
          ? this.getAttribute("data-swiper_m_num")
          : slider_ipad_num;
        const prevButton = this.querySelector(".swiper-button-prev");
        const nextButton = this.querySelector(".swiper-button-next");
        const scrollbar = this.querySelector(".swiper-scrollbar");
        const pagination = this.querySelector(".swiper-pagination");
        const swiper_auto=this.getAttribute("data-swiper_auto")=='true'?true:false
        const swiper_auto_time=this.getAttribute("data-swiper_auto_time") * 1
        const loop= this.getAttribute("data-swiper_loop")=='true' ? true : false
        const speed= this.getAttribute("data-swiper_speed") * 1000
        let autoplay = false
        if(swiper_auto){
          autoplay = {
              delay: swiper_auto_time,
              stopOnLastSlide: false,
              disableOnInteraction: true,
            }
        }
        this.swiper = new Swiper(this.swiper_obj, {
          slidesPerView: slider_pc_num,
          spaceBetween: 20,
          autoplay:autoplay,
          loop:loop,
          speed: speed , 
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            1024: {
              spaceBetween: 15,
              slidesPerView: slider_ipad_num,
            },
            589: {
              spaceBetween: 10,
              slidesPerView: slider_m_num,
            },
          },
        });
      }
      initVideoBtnClickEvent() {
        for (let btn_item of this.video_btn) {
          btn_item.addEventListener("click", () => {
            const index = Number(btn_item.dataset.index);
            if (Number.isNaN(index)) return;
            const flag =
              btn_item.getAttribute("data-video_fullscreen") == "true"
                ? true
                : false;
            const currentIndex = Number(this.current_index);
            const player = this.player_list[index];
            if (!player) return;
            const isCurrent = currentIndex === index;
            const isPlaying = !player.paused;
            if (isCurrent && isPlaying) {
              this.pauseVideoFn(index);
              return;
            }
            if (!isCurrent && this.video_btn[currentIndex]) {
              this.pauseVideoFn(currentIndex);
            }
            this.playVideoFn(index);
            if (
              flag &&
              this.allow_fullscreen &&
              player.fullscreen &&
              !player.fullscreen.active
            ) {
              player.fullscreen.enter();
            }
          });
        }
      }
      playVideoFn(play_index) {
        const index = Number(play_index);
        if (Number.isNaN(index) || !this.video_btn[index]) return;
        this.current_index = index;
        this.video_btn[index].classList.add("active");
        this.video_btn[index]
          .closest(".index-swiper-item")
          .classList.add("active");
        this.player_list[index] &&
          this.player_list[index].paused &&
          this.player_list[index].play();
      }
      pauseVideoFn(pause_index) {
        const index = Number(pause_index);
        if (Number.isNaN(index) || !this.video_btn[index]) return;
        this.video_btn[index].classList.remove("active");
        this.video_btn[index]
          .closest(".index-swiper-item")
          .classList.remove("active");
        this.player_list[index] &&
          !this.player_list[index].paused &&
          this.player_list[index].pause();
      }
      playFirstVideo() {
        let flag=this.video_btn[0] && this.video_btn[0].getAttribute("data-video_loop") == 'true' ? true : false
        
        if (this.player_list[0]) {
          this.player_list[0].on("ready", (event) => {
            this.player_list[0].muted = true;
            this.player_list[0].volume = 0;
            if(flag){
              this.player_list[0].loop = { active: true };
            }
            if(this.video_first_play){
              this.playVideoFn(0);
            }
          });
        }
        if(!flag) this.detectLoopVideo();
      }
      detectLoopVideo() {
        for (let item of this.youtube_list) {
          let j = +item.dataset.index;
          this.player_list[j] && this.player_list[j].on("ended", (event) => {
            this.pauseVideoFn(j);
            j + 1 < this.size &&
              this.player_list[j + 1] &&
              this.swiper.slideTo(j + 1) &&
              this.playVideoFn(j + 1);
          });
        }
      }
      initLineClamp(){
        const all_ele=this.querySelectorAll(".ellipsis-content")
        const btn_ele=this.querySelectorAll(".index-linka")
        if(!all_ele || !btn_ele) return ;
        const single_h=getComputedStyle(this.querySelector(".ellipsis-content")).lineHeight.replace("px","")
        const three_h = Math.ceil(single_h * 3)   
        for (let all_item of all_ele) {
           let content_h= Math.ceil(all_item.offsetHeight)
           if(content_h > three_h){
              all_item.classList.add("text-ellipsis")
           }else{
             all_item.closest(".content").classList.add("no-more")
           }
        }
        for(let btn_item of btn_ele){
           btn_item.addEventListener("click", () => {
               if(btn_item.closest(".content").classList.contains("active")){
                 btn_item.innerText='Learn More'
               }else{
                 btn_item.innerText='Learn Less'
               }
               btn_item.closest(".content").classList.toggle("active")

           })
        }
      }
    }
    customElements.define("index-swiper", IndexSwiper);
  }
});
